import React from 'react'
// import { menudb } from "./menudb.js";
import fondoMaderaGrande from '../../imagenes/fondoMaderaGrande.webp';
import fondoMaderaPequeno from '../../imagenes/fondoMaderaPequeno.webp';
// const dbmenuproducts = [...menudb];

function Bebidas() {
  return (
    <div
    id='bebidas'
    className="min-h-screen bg-cover bg-center bg-no-repeat px-6 py-10 overflow-hidden flex flex-col items-center justify-center "
  >
    <div className='text-3xl text-white'>PROXIMAMENTE... </div>
     <style>
  {`
    @media (max-width: 768px){
      #bebidas{
        background-image: url(${fondoMaderaPequeno});
      }  
    }
    @media (min-width: 768px) {
      #bebidas {
        background-image: url(${fondoMaderaGrande});
      }
    }
  `}
</style></div>
  )
}

export default Bebidas